module.exports = __webpack_public_path__ + "img/teacher2.bb1d501f.png";